
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useCustomerServiceContent } from '@/components/agents/industry/content/customerService';
import IndustryPage from '@/components/agents/industry/IndustryPage';
export default function CustomerServiceAgents() {
    const content = useCustomerServiceContent();
    return <IndustryPage content={content}/>;
}

    async function __Next_Translate__getStaticProps__1a167d9f350__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chatbots/customer-service',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a167d9f350__ as getStaticProps }
  